import React, { useState, useEffect } from "react";
import '../../css/customBreadcrumbs.css';
import { useMobileMediaQuery, useTabletMediaQuery, useMobileBtnBackMediaQuery } from "../../utils";
import { Link, useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from "react-icons/fa6";
import { useDispatch, useSelector } from 'react-redux';
import { setStartSpend } from '../../features/onboardingData/onboardingUserData';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import IconMyMedisSvg from '../../assets/svg/iconMyMedisBreadcrumbs.svg';
import IconLeftSvg from '../../assets/svg/iconLeftBreadcrumbs.svg';

const CustomBreadcrumbsAddCards


= (props) => {

    const {
        hasBtnBack = true,
        hasPadding = false,
        goHome = false,
        hasCardType = false,
        hasMbWay = false,
        hasMb = false,
    } = props;

    const navigate = useNavigate();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const isMobileBtnBack = useMobileBtnBackMediaQuery();
    const isStartSpend = useSelector((state) => state.onboardingUserData.isStartSpend);
    const dispatch = useDispatch();

    const handleGoBackClick = () => {
        navigate(-1);
        dispatch(setStartSpend(false));
    };

    const handleGoHomeClick = () => {
        navigate('/');
        dispatch(setStartSpend(false));
    };

    function handleClickNavList(event) {
        event.preventDefault();
    }

    const mainViewContainerCustomBreadcrumbs = hasPadding ? 
    ( isTablet ? 'mainViewContainerHasPaddingCustomBreadcrumbs' : ( isMobile ? 'mainViewContainerHasPaddingCustomBreadcrumbsTablet' : 'mainViewContainerHasPaddingCustomBreadcrumbsMobile' ) ) : 
    ( isTablet ? 'mainViewContainerCustomBreadcrumbs' : ( isMobile ? 'mainViewContainerCustomBreadcrumbsTablet' : 'mainViewContainerCustomBreadcrumbsMobile' ) );

    const handkeChangeMaxLength = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.slice(0, maxLength) + '...';
        }
        return text;
    };

    const containerCustomBreadcrumbsMobile = 
        (!hasCardType && !hasMbWay && !hasMb) ? 'containerCustomBreadcrumbsOneMobile' :
        (hasCardType && !hasMbWay && !hasMb) ? 'containerCustomBreadcrumbsTwoMobile' : 
        (hasCardType && (hasMbWay || hasMb)) ? 'containerCustomBreadcrumbsThreeMobile' : 'containerCustomBreadcrumbsMobile'
    
    return (
        <div className={mainViewContainerCustomBreadcrumbs}>
            { isTablet ?
                <div className='containerCustomBreadcrumbs' role="presentation" >
                    <Breadcrumbs aria-label="breadcrumb" className='txtNavListCustomBreadcrumbs'>
                        <div className='redirectNavViewContainerCustomBreadcrumbs'>
                            <a href="https://minhamedis-saude360.medis.pt/UmbrellaApplication_FE/Home" target="_blank" rel="noopener noreferrer" className="linkStyleRedirectNavCustomBreadcrumbs">
                                <img className='medisUserMenuSvgIconNavListCustomBreadcrumbs' src={IconMyMedisSvg} alt="imagem" />
                                <div className='txtNavListCustomBreadcrumbs'>Minha Médis</div>
                            </a>
                        </div>
                        <Link to="/" className="linkStyleCustomBreadcrumbs">
                            <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                <div className='txtNavListCustomBreadcrumbs'>Carteira Virtual Médis</div>
                            </div>
                        </Link>
                        { hasCardType &&
                            <Link to="/configuracoes/associar-cartao/tipo-de-associacao" className="linkStyleCustomBreadcrumbs">
                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                    <div className='txtNavListCustomBreadcrumbs'>Tipo de Associacao </div>
                                </div>
                            </Link>
                        }
                        { hasMbWay &&
                            <Link to="/configuracoes/associar-cartao/mbway" className="linkStyleCustomBreadcrumbs">
                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                    <div className='txtNavListCustomBreadcrumbs'>MB WAY</div>
                                </div>
                            </Link>
                        }
                        { hasMb &&
                            <Link to="/configuracoes/associar-cartao/multibanco" className="linkStyleCustomBreadcrumbs">
                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                    <div className='txtNavListCustomBreadcrumbs'>Multibanco</div>
                                </div>
                            </Link>
                        }
                    </Breadcrumbs>
                </div>
                : ( isMobile ? (
                    <div className='containerCustomBreadcrumbs' role="presentation" >
                        <Breadcrumbs aria-label="breadcrumb" className='txtNavListCustomBreadcrumbs'>
                            <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                <a href="https://minhamedis-saude360.medis.pt/UmbrellaApplication_FE/Home" target="_blank" rel="noopener noreferrer" className="linkStyleRedirectNavCustomBreadcrumbs">
                                    <img className='medisUserMenuSvgIconNavListCustomBreadcrumbs' src={IconMyMedisSvg} alt="imagem" />
                                    <div className='txtNavListCustomBreadcrumbs'>Minha Médis</div>
                                </a>
                            </div>
                            <Link to="/" className="linkStyleCustomBreadcrumbs">
                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                    <div className='txtNavListCustomBreadcrumbs'>Carteira Virtual Médis</div>
                                </div>
                            </Link>
                            { hasCardType &&
                                <Link to="/configuracoes/associar-cartao/tipo-de-associacao" className="linkStyleCustomBreadcrumbs">
                                    <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                        <div className='txtNavListCustomBreadcrumbs'>Tipo de Associacao </div>
                                    </div>
                                </Link>
                            }
                            { hasMbWay &&
                                <Link to="/configuracoes/associar-cartao/mbway" className="linkStyleCustomBreadcrumbs">
                                    <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                        <div className='txtNavListCustomBreadcrumbs'>MB WAY</div>
                                    </div>
                                </Link>
                            }
                            { hasMb &&
                                <Link to="/configuracoes/associar-cartao/multibanco" className="linkStyleCustomBreadcrumbs">
                                    <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                        <div className='txtNavListCustomBreadcrumbs'>Multibanco</div>
                                    </div>
                                </Link>
                            }
                        </Breadcrumbs>
                    </div>
                    ) : (
                        <div className='mainContainerCustomBreadcrumbsMobile'>
                            { hasCardType &&
                                <div className='goBackdMainViewContainerCustomBreadcrumbsMobile'>
                                    <div className='goBackBtnViewCustomBreadcrumbsMobile'>
                                        <button className='txtGoBackBtnCustomBreadcrumbsMobile'  type='button' onClick={ goHome ? handleGoHomeClick : handleGoBackClick} >
                                            <img className='goBackIconCustomBreadcrumbsMobile' src={IconLeftSvg} alt="imagem" />
                                        </button>
                                    </div>
                                </div>
                            }
                            <div className={containerCustomBreadcrumbsMobile} role="presentation" >
                                    <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                        <a href="https://minhamedis-saude360.medis.pt/UmbrellaApplication_FE/Home" target="_blank" rel="noopener noreferrer" className="linkStyleRedirectNavCustomBreadcrumbs">
                                            <img className='medisUserMenuSvgIconNavListCustomBreadcrumbs' src={IconMyMedisSvg} alt="imagem" />
                                            <div className='txtNavListCustomBreadcrumbs'>Minha Médis</div>
                                        </a>
                                    </div>
                                    <div className='txtNavListBreakViewCustomBreadcrumbsMobile'>
                                        <div className='txtNavListCustomBreadcrumbs'>/</div>
                                    </div>
                                    <Link to="/" className="linkStyleCustomBreadcrumbs">
                                        <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                            <div className='txtNavListCustomBreadcrumbs'>Carteira Virtual Médis</div>
                                        </div>
                                    </Link>
                                    { hasCardType &&
                                        <>
                                            <div className='txtNavListBreakViewCustomBreadcrumbsMobile'>
                                                <div className='txtNavListCustomBreadcrumbs'>/</div>
                                            </div>
                                            <Link to="/configuracoes/associar-cartao/tipo-de-associacao" className="linkStyleCustomBreadcrumbs">
                                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                                    <div className='txtNavListCustomBreadcrumbs'>Tipo de Associacao </div>
                                                </div>
                                            </Link>
                                        </>
                                    }
                                    { hasMbWay &&
                                        <>
                                            <div className='txtNavListBreakViewCustomBreadcrumbsMobile'>
                                                <div className='txtNavListCustomBreadcrumbs'>/</div>
                                            </div>
                                            <Link to="/configuracoes/associar-cartao/mbway" className="linkStyleCustomBreadcrumbs">
                                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                                    <div className='txtNavListCustomBreadcrumbs'>MB WAY</div>
                                                </div>
                                            </Link>
                                        </>
                                    }
                                    { hasMb &&
                                        <>
                                            <div className='txtNavListBreakViewCustomBreadcrumbsMobile'>
                                                <div className='txtNavListCustomBreadcrumbs'>/</div>
                                            </div>
                                            <Link to="/configuracoes/associar-cartao/multibanco" className="linkStyleCustomBreadcrumbs">
                                                <div className='redirectNavViewContainerCustomBreadcrumbs'>
                                                    <div className='txtNavListCustomBreadcrumbs'>Multibanco</div>
                                                </div>
                                            </Link>
                                        </>
                                    }
                            </div>
                        </div>
                    )
                )
            }

           
            { ( hasBtnBack && !isMobileBtnBack ) &&
                <div className='goBackdMainViewContainerCustomBreadcrumbs'>
                    <div className='goBackBtnViewCustomBreadcrumbs'>
                        <button className='txtGoBackBtnCustomBreadcrumbs'  type='button' onClick={ goHome ? handleGoHomeClick : handleGoBackClick} >
                            <FaArrowLeftLong className='goBackIconCustomBreadcrumbs' /> Voltar
                        </button>
                    </div>
                </div>
            }
        </div>
    );
};

export default CustomBreadcrumbsAddCards;